import { isBrowser } from '@zapier/common-utils';

const NoSSR = props => {
  return isBrowser() ? props.children : null;
};

export default NoSSR;
